<template>
  <div class="app-container withdraw">
    <el-col :span="9">
      <el-button size="small" type="primary" style="margin-left: 15px;" @click="showCashOut">申请提现</el-button>
    </el-col>
    <el-col :span="15">
      <div class="header" style="margin-bottom:10px">
        时间段
        <el-date-picker
          v-model="listQuery.start_datetime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择开始时间"
        ></el-date-picker>至
        <el-date-picker
          v-model="listQuery.end_datetime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择结束时间"
        ></el-date-picker>

        <el-button size="small" type="primary" style="margin-left: 15px;" @click="search">搜索</el-button>
      </div>
    </el-col>

    <panelGroup :detail="detail" v-if="detail" />
    <!-- <div class="fenxiao">￥总营业额: {{commission_total?commission_total:0}}</div>
    <div class="fenxiao">￥已提现: {{withdrawn_total}}</div>
    <div class="fenxiao">待提现: {{wait_withdrawn_total}}</div>-->

    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="序号" align="center" width="95">
        <template slot-scope="scope">{{scope.$index+1}}</template>
      </el-table-column>
      <el-table-column label="店铺名称" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.shop.name}}</template>
      </el-table-column>
      <el-table-column label="提现金额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.money}}</template>
      </el-table-column>
      <el-table-column label="实际到账" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.actual_receipt.toFixed(2)}}</template>
      </el-table-column>
      <el-table-column label="扣除佣金" align="center" min-width="110">
        <template slot-scope="scope">{{(scope.row.commission - 0).toFixed(2)}}</template>
      </el-table-column>
      <el-table-column label="提现后余额" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.after_balance}}</template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.status==1">待审核</el-tag>
          <el-tag type="info" v-if="scope.row.status==3">拒绝</el-tag>
          <el-tag type="success" v-if="scope.row.status==2">已通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.created_at}}</template>
      </el-table-column>
      <el-table-column label="处理时间" align="center" min-width="110">
        <template slot-scope="scope">{{scope.row.updated_at}}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <!-- <el-button size="small" type="primary" @click="handlePass(scope.row.id)" v-if="scope.row.status == 1">通过</el-button> -->
          <el-button
            size="small"
            type="warning"
            @click="handleWatch(scope.row)"
            v-if="scope.row.status == 2"
          >查看凭证</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10,20,30,100]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <el-dialog
      title="申请提现"
      :visible.sync="cashOutVisible"
      :close-on-click-modal="false"
      width="430px"
    >
      <el-form
        ref="shopCashOut"
        :model="form"
        label-position="left"
        label-width="70px"
        style="width: auto; margin-left:50px;"
      >
        <el-form-item label="余额" prop="balance" label-width="100px">{{balance}}</el-form-item>
        <el-form-item label="提现金额" prop="money" label-width="100px">
          <el-input v-model="form.money" placeholder />
        </el-form-item>
        <el-form-item label="扣除佣金" prop label-width="100px">{{(form.money*commission_rate - 0).toFixed(2)}}</el-form-item>
        <el-form-item
          label="实际到账"
          prop
          label-width="100px"
        >{{(form.money-form.money*commission_rate).toFixed(2)}}</el-form-item>
        <el-form-item label="提现后余额" prop label-width="100px">{{(balance-form.money - 0).toFixed(2)}}</el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cashOutVisible = false">返回</el-button>
        <el-button type="primary" @click="onSumbit" :loading="btnLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import panelGroup from "@/components/panelGroup1/index.vue";
export default {
  components: {
    // statistical
    panelGroup
  },
  data() {
    return {
      detail: {},
      listLoading: false,
      btnLoading: false,
      cashOutVisible: false,
      balance: 0,
      commission_rate: 0,
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        start_datetime: "",
        end_datetime: "",
        keyword: ""
      },
      form: {
        money: 0
      },
      list: [],
      // commission_total: 0,
      // withdrawn_total: 0,
      // wait_withdrawn_total: 0,
      commissionRate: ""
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/shop/cashOut/index",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.detail = result.data.detail;
          // this.commission_total = result.data.business_total_price;
          // this.withdrawn_total = result.data.withdrawn_total;
          // this.wait_withdrawn_total = result.data.wait_withdrawn_total;
          this.listLoading = false;
        })
        .catch(err => {})
        .finally(err => {});
    },
    handlePass(val) {
      this.$confirm("此操作将提现通过, 是否继续?", "提示", {
        confirmButtonText: "通过",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/shop/shop/cashOut/agree",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleWatch(row) {
      this.$router.push("/finance/cashout?id=" + row.id + "&type=watch");
    },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    showCashOut() {
      request({
        url: "/api/shop/cashOutDetail",
        method: "get",
        params: ""
      }).then(response => {
        this.balance = response.data.balance;
        this.commission_rate = response.data.commission_rate;
        this.cashOutVisible = true;
      });
    },
    onSumbit() {
      if (this.balance - this.form.money < 0) {
        this.$message({
          type: "error",
          message: `余额不足`
        });
        return;
      }
      this.btnLoading = true;
      request({
        url: "/api/shop/shop/cashout",
        method: "post",
        data: this.form
      })
        .then(response => {
          this.btnLoading = false;
          this.$notify({
            title: "成功",
            message: "提交成功",
            type: "success",
            duration: 2000
          });
          this.cashOutVisible = false;
          this.getList();
        })
        .catch(err => {
          this.btnLoading = false;
        });
    }
  }
};
</script>

<style>
.fenxiao {
  display: inline-block;
  padding: 20px 30px;
  margin-right: 20px;
  background-color: rgba(255, 0, 0, 0.438);
  color: #ffffff;
  margin-top: 10px;
  border-radius: 30px;
}
</style>
